import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";

function Inquiry() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  function Add_order(e) {
    e.preventDefault();
    setShowModal(true);
  }

  function closeModal() {
    setShowModal(false);
    navigate(-1);
  }

  return (
    <>
      <Header />
      <br />
      <br />
      <br />
      <div className="page-content">
        <div className="card card-style">
          <div className="content">
            <form onSubmit={Add_order}>
              {/* All your form inputs */}
              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                <input
                  type="text"
                  name="dealer_firm_name"
                  className="form-control"
                  placeholder="Name"
                  required
                />
                <label className="color-highlight">Name</label>
              </div>
              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                <input
                  type="number"
                  name="dealer_number"
                  className="form-control"
                  placeholder="Number"
                  required
                />
                <label className="color-highlight">Number</label>
              </div>
              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                <input
                  type="email"
                  name="dealer_email"
                  className="form-control"
                  placeholder="Email"
                  required
                />
                <label className="color-highlight">Email</label>
              </div>
              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                <input
                  type="text"
                  name="dealer_city"
                  className="form-control"
                  placeholder="City"
                  required
                />
                <label className="color-highlight">City</label>
              </div>
              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                <input
                  type="text"
                  name="dealer_state"
                  className="form-control"
                  placeholder="State"
                  required
                />
                <label className="color-highlight">State</label>
              </div>
              <div className="input-style input-style-always-active has-borders no-icon validate-field mb-4">
                <input
                  type="text"
                  name="dealer_message"
                  className="form-control"
                  placeholder="Message"
                  required
                />
                <label className="color-highlight">Message</label>
              </div>

              <button
                type="submit"
                style={{ width: "100%" }}
                className="btn btn-3d btn-m btn-full mb-3 rounded-xl text-uppercase font-900 shadow-s border-red-dark bg-red-light"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />

      {/* Modal */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "30px",
              borderRadius: "10px",
              width: "90%",
              maxWidth: "400px",
              textAlign: "center",
              boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
            }}
          >
            <h3>Inquiry Submitted!</h3>
            <p>
              Thanks for reaching out! Our team will review your message and get
              back to you soon.
            </p>

            <button
              onClick={closeModal}
              style={{
                marginTop: "20px",
                padding: "10px 20px",
                border: "none",
                background: "#ff4d4d",
                color: "#fff",
                borderRadius: "5px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default Inquiry;
